<template>
  <div class="notification-container">
    <transition-group name="toast">
      <div 
        v-for="toast in notifications" 
        :key="toast.id" 
        class="toast-item"
        :class="toast.type"
        @click="remove(toast.id)"
      >
        <div class="toast-icon">{{ getIcon(toast.type) }}</div>
        <div class="toast-content">{{ toast.message }}</div>
        <div class="scan-line"></div>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useNotificationStore } from '../store/notifications';

const store = useNotificationStore();
const notifications = computed(() => store.queue);

const remove = (id) => {
  store.removeNotification(id);
};

const getIcon = (type) => {
  switch (type) {
    case 'success': return '✅';
    case 'alert':
    case 'error': return '⚠️';
    case 'reward': return '🎁';
    default: return 'ℹ️';
  }
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9999;
  pointer-events: none; /* Allow clicks through container */
}

.toast-item {
  pointer-events: auto;
  min-width: 300px;
  padding: 1rem;
  background: rgba(10, 15, 25, 0.95);
  border: 1px solid #00f0ff;
  border-left: 4px solid #00f0ff;
  color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 15px rgba(0, 240, 255, 0.2);
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: 'Rajdhani', sans-serif;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(5px);
}

.toast-item.success {
  border-color: #a3be8c;
  box-shadow: 0 0 15px rgba(163, 190, 140, 0.2);
}

.toast-item.alert,
.toast-item.error {
  border-color: #bf616a;
  box-shadow: 0 0 15px rgba(191, 97, 106, 0.2);
}

.toast-item.reward {
  border-color: #ebcb8b;
  box-shadow: 0 0 15px rgba(235, 203, 139, 0.2);
}

.toast-content {
  font-size: 0.95rem;
  font-weight: 500;
  text-shadow: 0 0 5px rgba(0,0,0,0.5);
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: rgba(255,255,255,0.3);
  animation: scan 2s linear infinite;
  opacity: 0.5;
}

@keyframes scan {
  0% { transform: translateY(0); }
  100% { transform: translateY(100%); }
}

/* Transitions */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.4s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
